import {
  SvgCompany,
  SvgFormUser,
  SvgPhone,
  SvgEnvelop,
} from "../../assets/icons";
import { WithIconTextareaFormInput } from "../generic/forms/withIconTextAreaFormInput";
import { SelectPickerFormInput } from "../generic/forms/selectPickerFormInput.component";
import { RadioFormInput } from "../generic/forms/RadioFormInput.component";
import { DateFormInput } from "../generic/forms/DateFormInput.component";
import { useEffect, useState } from "react";
import { UtilityDate } from "../generic/dateUtil";
import { UserAddFormType } from "../../models/forms/usersAddForm";
import { TrialUserExpiredData } from "../../core/ConstData/UserConstData";
import { paidFeaturesStaticData } from "../../data/paidFeaturesStaticData";
import isBefore from "date-fns/isBefore";

export const UsersAddForm = ({
  isPaid,
  formValue,
  expiredDateChange,
}: {
  isPaid: boolean;
  formValue: UserAddFormType;
  expiredDateChange: (date: Date, expireCount: number | string) => void;
}) => {
  const [expireDayCount, setExpireDayCount] = useState<number | string>(0);
  const [expiredDate, setExpiredDate] = useState<Date | undefined>(new Date());
  const [isTrialSelect, setIsTrial] = useState<boolean>();

  const handleExpireDateValue = () => {
    if (expireDayCount === 3)
      expiredDateChange(UtilityDate.addThreeMonthDate(new Date()), 3);
    else if (expireDayCount === 1)
      expiredDateChange(UtilityDate.addOneMonthDate(new Date()), 1);
    else if (expireDayCount === 2)
      expiredDateChange(UtilityDate.addTwoDaysDate(new Date()), 2);
    else if (expireDayCount === 7)
      expiredDateChange(UtilityDate.addSevenDaysDate(new Date()), 7);
    else if (expireDayCount === 12)
      expiredDateChange(UtilityDate.addOneYearDate(new Date()), 12);
    else
      expiredDateChange(expiredDate ? expiredDate : new Date(), expireDayCount);
  };
  const handleExpiredDateManulChange = (date: Date) => {
    setExpiredDate(date);
    expiredDateChange(
      date,
      parseInt(
        (
          Math.abs(date.getTime() - new Date().getTime()) /
          (1000 * 60 * 60 * 24)
        ).toPrecision()
      ).toString() + "d"
    );
  };
  useEffect(() => {
    handleExpireDateValue();
  }, [expireDayCount]);

  useEffect(() => {
    if (formValue.expireDayCount) {
      setExpireDayCount(formValue.expireDayCount);
    }
    setExpiredDate(formValue.expiryDate);
  }, [formValue]);

  useEffect(() => {
    if (isTrialSelect) {
      setExpireDayCount(1);
      expiredDateChange(UtilityDate.addOneMonthDate(new Date()), 1);
      if (!formValue.expiryDate)
        setExpiredDate(UtilityDate.addOneMonthDate(new Date()));
    } else if (isTrialSelect === false) {
      setExpireDayCount(12);
      expiredDateChange(UtilityDate.addOneYearDate(new Date()), 12);
    }
  }, [isTrialSelect]);

  const onTrialOrPaidChecked = (isTrial: boolean) => {
    setIsTrial(isTrial);
  };

  return (
    <>
      <div className="d-flex flex-column px-3">
        <h6 className="mb-3 mt-1">Sign In Information</h6>
        <p className="fw-bold mb-1 card-text ms-1">Email *</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          placeholder="Please enter email"
          name="email"
          svgicon={SvgEnvelop}
          showError={true}
          errorText={"Email is required"}
        />
        <p className="fw-bold mt-3 mb-1 card-text ms-1">User Name *</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          placeholder="Please enter username"
          name="userName"
          svgicon={SvgFormUser}
          showError={true}
          errorText={"UserName is required"}
        />
        <h6 className="mb-3 mt-4">Basic Information</h6>
        <p className="fw-bold mb-1 card-text ms-1">First Name *</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          placeholder="Please enter firstname"
          name="firstName"
          svgicon={SvgFormUser}
          showError={true}
          errorText={"First name is required"}
        />
        <p className="fw-bold mt-3 mb-1 card-text ms-1">Last Name *</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          name="lastName"
          placeholder="Please enter lastname"
          svgicon={SvgFormUser}
          showError={true}
          errorText={"Last name is required"}
        />
        <p className="fw-bold mt-3 mb-1 card-text ms-1">Company Name</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          name="companyName"
          placeholder="Please enter company name"
          svgicon={SvgCompany}
        />
        <p className="fw-bold mt-3 mb-1 card-text ms-1">Type Of Company</p>
        <div className="p-0">
          <SelectPickerFormInput
            name="typeOfCompany"
            data={[
              { label: "Law Firm", value: "LawFirm" },
              { label: "Corporate", value: "Corporate" },
              { label: "Others", value: "other" },
            ]}
            placeholder="Law Firm"
            size="sm"
            placement="topStart"
            block
            searchable={false}
          />
        </div>
        <p className="fw-bold mt-3 mb-1 card-text ms-1">
          WTA Subscription Type *
        </p>
        <SelectPickerFormInput
          name="wtaSubType"
          data={[
            { label: "None", value: "0" },
            { label: "Basic", value: "1" },
            { label: "Emplus", value: "2" },
          ]}
          placeholder="None"
          size="sm"
          placement="topStart"
          block
          searchable={false}
          showError={true}
          errorPlacement="bottomEnd"
          errorText={"WTA subscription type is required"}
        />
        <p className="fw-bold mt-3 mb-1 card-text ms-1">
          TPA Subscription Type *
        </p>
        <SelectPickerFormInput
          name="tpaSubType"
          data={[
            { label: "None", value: "0" },
            { label: "Basic", value: "1" },
            { label: "Emplus", value: "2" },
          ]}
          placeholder="None"
          size="sm"
          placement="topStart"
          block
          searchable={false}
          showError={true}
          errorPlacement="bottomEnd"
          errorText={"TPA subscription type is required"}
        />
        <p className="fw-bold mt-3 mb-1 card-text ms-1">
          Paid Feature Subscription
        </p>{" "}
        <SelectPickerFormInput
          name="paidFeatureSubscriptionType"
          data={Object.entries(paidFeaturesStaticData)
            .filter(([key]) => isNaN(Number(key)))
            .map(([key]) => ({
              label: key,
              value: key,
            }))}
          placeholder="Select Paid Feature"
          // defaultValue={paidFeaturesStaticData.None.toString()}
          size="sm"
          placement="topStart"
          block
          searchable={false}
          // showError={true}
          // errorPlacement="topEnd"
        />
        <p className="fw-bold mt-3 mb-1 card-text ms-1">Phone Number</p>
        <WithIconTextareaFormInput
          className=" m-0 w-100"
          name="phoneNumber"
          placeholder="Please enter phone number"
          svgicon={SvgPhone}
        />
        <h6 className="mb-3 mt-4">Account Details</h6>
        <div className="d-flex mt-1">
          <RadioFormInput
            name="userType"
            showError={true}
            errorText={"User type is required"}
            onTrialOrPaidChecked={onTrialOrPaidChecked}
          />
        </div>
        <div className="d-flex mt-1 ms-2 align-items-center mb-3 flex-row">
          <div className="d-flex flex-row align-items-center">
            <div
              className={`d-flex ${isPaid ? "disable-cursor disabled" : ""}`}
            >
              <p>Registered Date</p>
              <DateFormInput name="registrationDate" />
              <p className="ms-4">Expire Date</p>
              <DateFormInput
                name="expiryDate"
                value={expiredDate}
                disabledDate={(date: Date | undefined) =>
                  date !== undefined ? isBefore(date, new Date()) : false
                }
                onChange={(date) => handleExpiredDateManulChange(date)}
              />
            </div>
            {!isPaid ? (
              <div className="pl-2 text-dark">
                <SelectPickerFormInput
                  name="expireDayCount"
                  value={expireDayCount}
                  data={TrialUserExpiredData}
                  size="xs"
                  placement="topEnd"
                  searchable={false}
                  isCleanable={false}
                  onChange={(value) => setExpireDayCount(value)}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
